import QuickNav from "../../HomePage/HeroSection/QuickNav";
import CustomProducts from "./CustomProducts/CustomProducts";
import Lifecycle from "./Lifecycle/Lifecycle";
import ServiceDevBanner from "../../AllServices/Customer-Service-Development/ServiceDev";
import { CustomSoftwareServices } from "../CustomSoftwareDev/Service/CustomSoftwareServices";
import FooterContact from "../../FooterContactPage/FooterContact";
import HowServicePage from "../../How-ServicePage/how-service";
import { useEffect } from "react";
import ClientTestimony from "../CustomSoftwareDev/Testimony/ClientTestimony";
import CustomSoftwareDevFaq from "../CustomSoftwareDev/CustomSoftwareDevFaq/CustomSoftwareDevFaq";
import { Helmet } from "react-helmet-async";

const CustomSoftware = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const QuickNavItems = [
    "Target Group",
    "Samples",
    "Our Process",
    "Our Stories",
    "How Manage",
    "FAQ",
  ];

  return (
    <div>
      <>
        <Helmet>
          <title>
            Custom Software Development in Bangladesh | Quad Theory Ltd
          </title>
          <meta
            name="description"
            content="Quad Theory Ltd provides custom software development in Bangladesh with dedicated offshore teams, clear communication, and long term support."
          />
        </Helmet>
      </>
      <title>Custom Software Development</title>
      <ServiceDevBanner />
      <main>
        <QuickNav items={QuickNavItems} />
        <CustomSoftwareServices />
        <CustomProducts />
        <Lifecycle />
        <ClientTestimony />
        <HowServicePage />
        <CustomSoftwareDevFaq />
      </main>
      <FooterContact />
    </div>
  );
};

export default CustomSoftware;
